import React from 'react';
import './projects.css';
import { ProjectCard } from './ProjectCard';
import { SideProjects } from './SideProjects';

import projImg1 from '../../assets/sevillereport.png';
import projImg3 from '../../assets/melete.png';


import interviewApp from '../../assets/interviewApp.jpg';

import { FaPython } from 'react-icons/fa'
import { SiDjango } from 'react-icons/si'
import { TbSql } from 'react-icons/tb'
import {SiPostgresql} from 'react-icons/si'

import { FaHtml5 } from 'react-icons/fa'
import { FaCss3Alt } from 'react-icons/fa'
import { DiJavascript1 } from 'react-icons/di'
import { FaReact } from 'react-icons/fa'


export const Projects = () => {
    const projects = [
        {
            title: 'The Seville Report',
            description: 'An Investment Newsletter Website',
            imgUrl: projImg1,
            techStack: [<SiDjango/>, <FaPython/>, <DiJavascript1/>, <FaHtml5/>, <FaCss3Alt/>, <SiPostgresql/>],
            signIn: '', 
            password: '',
            projectId: 1,
            githubLink: 'https://github.com/P-R-Black/SR_website/tree/master',
            liveUrl: 'https://sevillereport.com/'
        },
        {
            title: 'Melete',
            description: 'A Meditation App',
            imgUrl: projImg3,
            techStack: [<SiDjango/>, <FaPython/>, <DiJavascript1/>, <FaHtml5/>, <FaCss3Alt/>, <TbSql/>],
            signIn: 'Demo SignIn: tonystark@avengers.com', 
            password: 'Demo Password: IronMan123',
            projectId: 2,
            githubLink: 'https://github.com/P-R-Black/new_melete',
            liveUrl: 'https://melete.paulrblack.com'
        },
    ]

    const skill_builders = [
        {
            title: 'Interview Prep',
            description: 'React and Django Interview Prep',
            imgUrl: interviewApp,
            techStack:[ <FaReact/>, <FaHtml5/>, <FaCss3Alt/>],
            projectId: 3,
            githubLink: 'https://github.com/P-R-Black/Programming-Interview-Prep',
            liveUrl: 'http://interviewapp.paulrblack.com'
        }
    ]

  return (
    <section id="projects" className="project_section">
        <h5>My Recent
            <span className='animate scroll' style={{'--i':"1"}}></span>
        </h5>
        <h2>Projects
            <span className='animate scroll' style={{'--i':"2"}}></span>
        </h2>
        <div className="container project_container">
            {projects.map((project) => {
                return (
                    <ProjectCard
                    key={project.projectId}
                    {...project}
                />
                )})}
                <span className='animate scroll' style={{'--i':"3"}}></span>
        </div>
        
        <div className="container side_project_container">
            <h2 className="skill_builders">Skill Builders
            <span className='animate scroll' style={{'--i':"3"}}></span>
            </h2>
            <div className="side_project_divider"></div>
                <div className='side_project_section'>
                    {skill_builders.map((side) => {
                        return (
                            <SideProjects
                                key={side.projectId}
                                {...side}
                                
                            />
                        )
                    })}
                    <span className='animate scroll' style={{'--i':"4"}}></span>
                </div>
        </div>
    </section>
  )
}
